import { useLocation } from "react-router";
import TournamentPlayer from "../../type/TournamentPlayer";
import { Box, Center, Heading, Link, Text } from "@chakra-ui/react";
import { EmailIcon } from "@chakra-ui/icons";
import { ReactNode } from "react";
import { TournamentExtraInfo } from "../parts/tournamentInfo";
import { TournamentType } from "../../service/tournament";

type SuccessPageState = {
  tournamentplayer: TournamentPlayer;
  tournamentInfo: TournamentType;
};

// Declaration of the StyledListItem component
const StyledListItem: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <Text fontFamily={"Arial"} fontWeight={900}>
      {children}
      <br />
      <br />
    </Text>
  );
};

export function SuccessPage() {
  const location = useLocation();
  const { tournamentplayer, tournamentInfo } =
    location.state as SuccessPageState;

  return (
    <>
      <Center>
        <Box
          backgroundColor="#139D08"
          width={{
            base: "326px",
            sm: "422px",
            md: "634px",
            lg: "845px",
            xl: "1056px",
          }}
          pb="10px"
          mt="20px"
          p="20px"
        >
          <Heading textAlign={"center"} pb={3}>
            Bedankt {tournamentplayer.firstname} {tournamentplayer.lastname},
          </Heading>

          <StyledListItem>
            <Center>We hebben je inschrijving goed ontvangen.</Center>
          </StyledListItem>

          <TournamentExtraInfo tournamentInfo={tournamentInfo} />
        </Box>
      </Center>
    </>
  );
}
